(function () {
  var STORAGE_KEY = 'ventara-welcome-popup-dismissed';
  var popup = document.getElementById('welcome-popup');
  if (!popup) return;

  var alreadyOpen = popup.classList.contains('is-open');

  function openPopup() {
    popup.classList.add('is-open');
  }

  function closePopup() {
    popup.classList.remove('is-open');
    try {
      window.localStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {}
  }

  popup.querySelectorAll('[data-popup-dismiss]').forEach(function (el) {
    el.addEventListener('click', closePopup);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && popup.classList.contains('is-open')) {
      closePopup();
    }
  });

  if (!alreadyOpen) {
    var dismissed = false;
    try {
      dismissed = window.localStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {}

    if (!dismissed) {
      window.setTimeout(openPopup, 4000);
    }
  }
})();

document.addEventListener('click', function (event) {
  var button = event.target.closest('[data-copy-code]');
  if (!button) return;

  var code = button.getAttribute('data-copy-code');
  var hint = button.querySelector('.newsletter__code-copy-hint, .welcome-popup__code-copy-hint');
  var originalText = hint ? hint.textContent : null;

  function showCopied() {
    button.classList.add('is-copied');
    if (hint) hint.textContent = 'Copied!';
    window.setTimeout(function () {
      button.classList.remove('is-copied');
      if (hint && originalText) hint.textContent = originalText;
    }, 2000);
  }

  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(code).then(showCopied).catch(function () {});
  } else {
    var textarea = document.createElement('textarea');
    textarea.value = code;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand('copy');
      showCopied();
    } catch (e) {}
    document.body.removeChild(textarea);
  }
});
